import { render, staticRenderFns } from "./sidebarFilter.vue?vue&type=template&id=91ef1958&scoped=true&"
import script from "./sidebarFilter.vue?vue&type=script&lang=js&"
export * from "./sidebarFilter.vue?vue&type=script&lang=js&"
import style0 from "./sidebarFilter.vue?vue&type=style&index=0&id=91ef1958&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91ef1958",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCheckbox,VContainer})
